import { useBranding } from '../../../branding/useBranding'
import styles from './styles.module.scss'

function Footer() {
    const brand = useBranding()

    return (
        <footer className={styles.footer}>
            <div className={styles.innerFooter}>
                <img src={brand.logo} alt={brand.logoAlt} className={styles.logo} />
                {brand.footerText.map((line, index) => (
                    <p key={index} className={index === 0 ? styles.disclaimer : undefined}>
                        {line}
                    </p>
                ))}
            </div>
        </footer>
    )
}

export default Footer
